import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const RECENT_SALES = [{
  name: 'Romina S.',
  location: 'Córdoba'
}, {
  name: 'Gabriela M.',
  location: 'Rosario'
}, {
  name: 'Soledad P.',
  location: 'Buenos Aires'
}, {
  name: 'Mariana L.',
  location: 'Mendoza'
}, {
  name: 'Florencia R.',
  location: 'La Plata'
}, {
  name: 'Valentina T.',
  location: 'Tucumán'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const initialTimeout = setTimeout(() => setIsVisible(true), 4000);
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % RECENT_SALES.length);
        setIsVisible(true);
      }, 1000);
    }, 7000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, []);
  const currentSale = RECENT_SALES[currentIndex];
  return <AnimatePresence data-id="element-160">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0,
      y: 20
    }} animate={{
      x: 0,
      opacity: 1,
      y: 0
    }} exit={{
      x: -100,
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 z-40 max-w-xs md:max-w-sm" data-id="element-161">
          <div className="bg-white rounded-lg p-4 shadow-2xl border border-gray-200 relative group" data-id="element-162">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-300 hover:text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-163">
              <X size={14} data-id="element-164" />
            </button>

            <div className="flex items-start gap-3" data-id="element-165">
              <div className="bg-green-100 p-2 rounded-full mt-0.5" data-id="element-166">
                <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-167" />
              </div>
              <div data-id="element-168">
                <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-169">
                  <span className="font-bold text-gray-900" data-id="element-170">
                    {currentSale.name}
                  </span>{' '}
                  de {currentSale.location}
                </p>
                <p className="text-xs text-gray-500 mt-1" data-id="element-171">
                  acaba de adquirir el{' '}
                  <span className="text-amber-600 font-semibold" data-id="element-172">
                    MegaPack Reiki
                  </span>
                </p>
                <div className="flex items-center gap-1 mt-2" data-id="element-173">
                  <span className="text-[10px] text-gray-400 uppercase tracking-wider font-semibold" data-id="element-174">
                    Verificado por Hotmart
                  </span>
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-175"></div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}